import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapToolboxStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    buttonGroup: {
      backgroundColor: palette.background.paper,
      display: 'flex',
      flexDirection: 'column',
    },
    drawButton: {
      marginBottom: spacing(),
    },
  })
);

export default useMapToolboxStyles;
